import request from "@/api/request";

export default {
    // 验光预约列表
    getList: async data => request({url: '/console/orders.Optometry/getList', data}),

    // 查看验光数据
    getDetail: async data => request({url: '/console/orders.Optometry/getDetail', data}),
}
